import { IDashboardData } from '@/lib/interface';
import { useQuery } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TResponseData = IDashboardData;

const CONSTS = {
  defaultData: {
    reports: 0,
    photo: 0,
    bio: 0,
    id: 0,
    review: {
      photo: 0,
      id: 0
    }
  } as TResponseData
};

export const useRequestGetDashboardData = (run = true) => {

  const { isFetching, data, error, refetch: refetchDashboardData } = useQuery({
    queryKey: [routes.api.dashboard, run],
    queryFn: ({ queryKey: [_url, _run] }) =>
      !_run
        ? Promise.resolve(null)
        : fetchQuery(_url as string),
    staleTime: 0
  });

  let dataResult = (data ?? CONSTS.defaultData) as TResponseData;

  dataResult = ({
    ...dataResult,
    review: dataResult?.review ?? CONSTS.defaultData.review
  });

  const countReview = (
    dataResult.photo +
    dataResult.bio +
    dataResult.id
  );

  const fetchQuery = (url: string) =>
    apiClient
      .get<TResponseData>(url)
      .then(handleApiResponse);

  const fetchData = () =>
    fetchQuery(routes.api.dashboard);

  return ({
    isLoading: isFetching,
    data: dataResult,
    refetchDashboardData,
    countReview,
    fetchData,
    error
  });

};